import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { useCardContext } from 'dataProviders/Card'

const useCardBlockers = () => {
  const cardContext = useCardContext()

  const cardBlockers = useSelector<any, any[]>(useMemo(() => createSelector(
    [
      state => state.kanbo.cardBlockers.ids,
      state => state.kanbo.cardBlockers.byId,
      state => state.kanbo.blockers.byId,
    ],
    (
      cardBlockerIds,
      cardBlockersById,
      blockersById,
    ) =>
      cardBlockerIds
        .filter(cardBlockerId => cardBlockersById[cardBlockerId].cardId === cardContext.id)
        .map(cardBlockerId => ({
          ...blockersById[cardBlockersById[cardBlockerId].blockerId],
          ...cardBlockersById[cardBlockerId],
        }))
  ), [cardContext.id]))

  return cardBlockers
}

export default useCardBlockers